<template>
  <div>
    <table-grid
      ref="tableGrid"
      search-table
      @select="selectRegType"
      :headers="headers"
      :items="regTypes"
      :loading="loading"
      :multiple="true"
      :noPagination="true"
    />
  </div>
</template>

<script>
import regTypeService from "@/services/regTypeService";
import environmentService from "@/services/environmentService";
export default {
  props: ["value", "alerts"],
  data() {
    return {
      loading: false,
      regTypesSelect: [],
      regTypes: [],
      environments: [],
      headers: [
        {
          text: this.$t("entities.regType.props.description"),
          align: "left",
          sortable: false,
          value: "description"
        },
        {
          text: this.$t("entities.regType.props.environmentId"),
          align: "left",
          sortable: false,
          value: "environmentDescription"
        },
        {
          text: this.$t("entities.regType.props.stageRequired"),
          align: "left",
          sortable: false,
          value: "stageRequired"
        }
      ]
    };
  },
  watch: {
    async value() {
      await this.getRegTypes();
    }
  },
  methods: {
    selectRegType(regTypes) {
      this.regTypesSelect = regTypes;
      let ids = [];
      regTypes.forEach(rt => ids.push(rt.id));
      this.value.regTypeIds = ids;
    },
    updateRegTypeIds() {
      let regTypes = [];
      this.value.regTypeIds.filter(id => {
        let regType = this.regTypes.filter(rt => rt.id == id)[0];
        if (regType != null) regTypes.push(regType);
      });

      this.regTypesSelect = regTypes;
      this.$refs.tableGrid.selectRange(regTypes);
    },
    async getEnvironments() {
      let res = await environmentService.getAll();
      if (res.success) this.environments = res.data.data;
    },
    async getRegTypes() {
      this.loading = true;
      await this.getEnvironments();
      let res = await regTypeService.getAll();
      this.loading = false;
      if (res.success) {
        res.data.data.forEach(rt => {
          let environment = this.environments.filter(
            e => e.id == rt.environmentId
          )[0];

          if (environment != null)
            rt.environmentDescription = environment.description;
        });

        res.data.data.sort((a, b) => {
          if (a.environmentDescription > b.environmentDescription) return 1;
          else if (a.environmentDescription < b.environmentDescription)
            return -1;
          else return 0;
        });

        this.regTypes = res.data.data;
        this.updateRegTypeIds();
      }
    }
  },
  async mounted() {
    await this.getRegTypes();
  }
};
</script>